import * as tslib_1 from "tslib";
import { CheckboxGroupControl } from "../../../../../form/src/common/controls/checkbox-group-control";
import ControlBack from '../../../../../form/src/common/directives/control-back';
import { H3CheckboxList, H3RadioList } from 'h3-mobile-vue';
import { Component, Inject, Prop } from "vue-property-decorator";
let CheckboxGroup = class CheckboxGroup extends CheckboxGroupControl {
    constructor() {
        super(...arguments);
        this.showModal = false;
        this.tampValue = '';
    }
    show() {
        this.showModal = true;
        this.tampValue = this.ctrl.value;
    }
    close() {
        this.showModal = false;
        this.ctrl.value = this.tampValue;
    }
    //上下布局模式
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    get checkBoxTitle() {
        if (this.isSheetTable) {
            return '';
        }
        else {
            return this.label;
        }
    }
    clear() {
        //单选按钮点击请选择、清空按钮后清空值
        this.tampValue = '';
        // 移动端pop组件清除时模板值未清空问题
        try {
            const radioList = this.$refs.radioList;
            if (radioList && Array.isArray(radioList.$children)) {
                const popIntance = radioList.$children.find((item) => 'tempValue' in item);
                if (Array.isArray(popIntance.tempValue) && popIntance.tempValue.length > 0) {
                    popIntance.tempValue = [];
                }
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    onChange(val) {
        if (val) {
            if (this.isRadio) {
                this.tampValue = typeof val === 'string' ? val : val.value;
            }
            else {
                this.tampValue = val.slice();
                this.ctrl.value = val.slice();
            }
        }
        else {
            this.tampValue = '';
        }
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], CheckboxGroup.prototype, "isSheetTable", void 0);
tslib_1.__decorate([
    Inject()
], CheckboxGroup.prototype, "layoutTypeFn", void 0);
CheckboxGroup = tslib_1.__decorate([
    Component({
        name: "checkbox-group",
        components: {
            H3RadioList,
            H3CheckboxList
        },
        directives: {
            ControlBack,
        },
    })
], CheckboxGroup);
export default CheckboxGroup;
